import React from 'react'
import { Route, IndexRoute } from 'react-router'

import AdminAudit from '../components/admin-audit/list'

const AdminAuditRoute = (
  <Route path='admin-audit'>
    <IndexRoute component={AdminAudit} />
  </Route>
)

export default AdminAuditRoute
